import { render, staticRenderFns } from "./PosteView.vue?vue&type=template&id=fe48fbd0&scoped=true&"
import script from "./PosteView.vue?vue&type=script&lang=js&"
export * from "./PosteView.vue?vue&type=script&lang=js&"
import style0 from "./PosteView.vue?vue&type=style&index=0&id=fe48fbd0&prod&lang=scss&scoped=true&"
import style1 from "./PosteView.vue?vue&type=style&index=1&id=fe48fbd0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe48fbd0",
  null
  
)

export default component.exports